import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "./AfterSubmission.module.css";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect } from "react";
import { clearAttachmentFailures, clearPdf } from "../../store/actions/forms";
import { claimsMailBox } from "../../constants/messages";

function AfterSubmission() {
  const history = useHistory();
  const dispatch = useDispatch();
  let { refNumber } = useParams();

  const userInfo = useSelector((state) => state.user.userInfo);
  const agentInfo = useSelector((state) => state.user.agentInfo);
  const pdf = useSelector((state) => state.forms.wcPdf);
  const attachmentFailures = useSelector(
    (state) => state.forms.attachmentFailures
  );

  useEffect(() => {
    let unlisten = history.listen((location, action) => {
      if (!location.pathname.includes("claimsubmitted")) {
        dispatch(clearAttachmentFailures());
        dispatch(clearPdf());
      }
    });
    return () => {
      unlisten();
    };
  }, []);

  return (
    <div>
      <h1 className={styles.title}>Claim Received</h1>
      <p className={styles.regularText}>
        Thank you for submitting your claim with us online.
      </p>

      {refNumber && (
        <p className={styles.regularText}>
          {" "}
          Your claim number is{" "}
          <span className={styles.referenceNumber}>{refNumber}</span>.
        </p>
      )}

      <p className={styles.regularText}>
        {pdf && "An email confirmation will be sent to you. "}
        {!pdf && "A Claims Representative will contact you within 24 hours or on the next business day."}
      </p>
      {pdf && (
        <p className={styles.emphasized}>
          <em>IMPORTANT: </em> Please download a copy of your claim report now
          if you wish to retain it for your records
          <a
            href={pdf}
            download={`Claim ${refNumber}.pdf`}
            className={styles.download}
          >
            Claim {refNumber}.pdf
          </a>
          <br></br>
          It will be unavailable by email or in the Customer Care Center once
          you exit this screen.
        </p>
      )}
      {attachmentFailures?.length > 0 && (
        <p className={styles.emphasized}>
          <em>Note:</em> Your document{attachmentFailures.length > 1 && "s"}{" "}
          {attachmentFailures.map((fileName, index) =>
            index !== attachmentFailures.length - 1
              ? `"${fileName}", `
              : `"${fileName}"`
          )}{" "}
          failed to upload. Please email your document
          {attachmentFailures.length > 1 && "s"} to{" "}
          <a href={`mailto:${claimsMailBox}`}>{claimsMailBox}</a> and attention
          your claim number.
        </p>
      )}

      {userInfo ? (
        <button
          className={styles.button}
          onClick={(event) => {
            event.preventDefault();
            history.push("/view");
          }}
        >
          View Claims
        </button>
      ) : agentInfo ? (
        <button
          className={styles.button}
          onClick={(event) => {
            event.preventDefault();
            history.push("/policies");
          }}
        >
          View Policies
        </button>
      ) : null}
    </div>
  );
}

export default AfterSubmission;
